/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace component-selector */

import {Injectable}         from '@angular/core';

import {
  Observable,
  Subject
}                                     from 'rxjs';

import { Action                     } from '@/models/action';
import { ActionType                 } from '@/models/action.type';

import { Logger                     } from '@/util/logger';

import { Router                     } from '@angular/router';


@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class ActionService
 *
 * from anywhere in our application we can fetch and modify GUI Action items (commands),
 * and when we save modifications any watchers are notified of the change (so they can update
 * their presentation of the action).  The actions might be used in toolbars, buttons, menus
 * etc., but there is only ever one instance of a given action.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class ActionService {

  /** the actions we're managing */
  private actions: Map<ActionType, Action> = new Map<ActionType, Action>();

  /** when we "save", we push through an observable to "publish" the change */
  private subject   = new Subject<Action>();

  /** standard constructor */
  constructor(
    private router:  Router
  ) {

    /* fill the pool with all possible actions */

    Logger.debug('[ActionService] creating default actions...');




    Logger.debug('[ActionService] ready.');
  }

  /* subscribe to any changes in actions */
  onChange(): Observable<Action> {

    return this.subject.asObservable();
  }

  /** add a new action, we don't publish addition/creation, only later changes. */
  add(action: Action) {

    /* overwrite if it's already there  */

    this.actions.set(action.type, action);
  }

  /** fetch an action */
  action(type: ActionType) : Action {

    if (!this.actions.has(type)) {

      /* this action isn't managed */

      return null;
    }

    /* pas it back */

    return this.actions.get(type);
  }

  /** save an action back the service, so the change can be published */
  save(action: Action) {

    if (!this.actions.has(action.type)) {

      /* this action isn't managed */

      return ;
    }

    /* save it */

    this.actions.set(action.type, action);

    /* publish change */

    this.subject.next(action);
  }

}
